<div [formGroup]="travelTypeForm" *ngIf="travelTypeForm">
    Code
    <input formControlName="code">
    Type
    <p-dropdown formControlName="type" [options]="types" optionLabel="name"></p-dropdown>
    Description
    <input formControlName="description">
    Notes de facturation
    <input formControlName="billingNote">
    Commentaires généraux
    <input formControlName="comment">
    <button (click)="updateTravelType()">Submit</button>
</div>